var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMail(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_175_14)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.6671 13.2421C12.1696 13.5738 11.5916 13.7492 10.9957 13.7492C10.3998 13.7492 9.82187 13.5738 9.32429 13.2421L1.12886 7.77829C1.08339 7.74798 1.0391 7.71638 0.995697 7.68388V16.6369C0.995697 17.6634 1.8287 18.478 2.83683 18.478H19.1545C20.181 18.478 20.9957 17.645 20.9957 16.6369V7.68384C20.9522 7.71642 20.9078 7.7481 20.8622 7.77845L12.6671 13.2421Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.7789 6.8034L9.97433 12.2672C10.2846 12.4741 10.6401 12.5775 10.9957 12.5775C11.3512 12.5775 11.7068 12.474 12.0171 12.2672L20.2125 6.8034C20.7029 6.47664 20.9957 5.92977 20.9957 5.33953C20.9957 4.32465 20.17 3.49902 19.1552 3.49902H2.8362C1.82136 3.49906 0.995697 4.32469 0.995697 5.34051C0.995697 5.92977 1.28851 6.47664 1.7789 6.8034Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_175_14"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.995697 0.988525)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMail);
export default __webpack_public_path__ + "static/media/mail.04c272e052fb1a029aa28c8b7c7c814e.svg";
export { ForwardRef as ReactComponent };